import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import GiftOutlinedSvg from "@ant-design/icons-svg/es/asn/GiftOutlined";
import AntdIcon from "../components/AntdIcon";
var GiftOutlined = function GiftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GiftOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  GiftOutlined.displayName = 'GiftOutlined';
}
export default /*#__PURE__*/React.forwardRef(GiftOutlined);